import template from './leave_cancellation_request.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';

class LeaveCancellationRequestViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);
		this.leave_to_approve = ko.observableArray();
		this.sorting_method = ko.observable('approaching_first');
		this.leave_types = ko.observableArray();
		this.leave_type_id = ko.observable();
		this.departments = ko.observableArray();
		this.department_id = ko.observable();

		let leave_type_initial_update = false;
		let department_initial_update = false;

		this.sorting_method.subscribe((newText) => {
			this.page.updateData();
		});

		this.leave_type_id.subscribe((newText) => {
			if (leave_type_initial_update == false)
			{
				leave_type_initial_update = true;
				return;
			}
			this.page.updateData();
		});

		this.department_id.subscribe((newText) => {
			if (department_initial_update == false)
			{
				department_initial_update = true;
				return;
			}
			this.page.updateData();
		});
	};

	show_help()
	{
		Grape.dialog.open('LeaveCancelHelp', {});
	};

	async reject_leave(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('LeaveCancellationReject', data);
		this.page.updateData();
	};

	async approve_leave(v, e)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to accept the removal of this leave?')});
		if (response)
		{
			let data = ko.toJS(v);
			let row = $(e.currentTarget).parent().parent();

			if (data.transaction_id)
			{
				let res = await Grape.fetches.postJSON('/leave/accept_leave_cancellation_request', {transaction_id: data.transaction_id});
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully removed leave entry.'), title: tr('Success') });
					this.page.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });

				row.find('.edit').hide();
				row.find('.view').show();
			}
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong. Please contact Yooma.'), title: tr('Error') });
		}
	};

	/*async ping_managers(v, e) -- Not used anywhere or called in html?
	{
		let response = await Grape.alerts.alert({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to send a reminder to the manager to respond to these requests ?')});
		if(response)
		{
			let res = await Grape.fetches.postJSON('/general/ping_reminder_to_manager_for_leave_request_made', { employee_id: v.employee_id });
			if (res.status == 'OK')
				Grape.alerts.alert({ type: 'success', message: tr('Successfully sent reminder.'), title: tr('Success') });
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	};*/
};

class LeaveCancellationRequest 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new LeaveCancellationRequestViewModel(this);	
	}

	async init()
	{
		document.title = tr('Leave Cancellation Requests');
		window.current_page_title(tr('Leave Cancellation Requests'));

		// get all leave types
		let res_type = await Grape.fetches.getJSON('/api/record', { 
			table: 'leave_type',
			limit: 100,
			sortfield: 'description',
			sortorder: 'asc' 
		});

		if (res_type.status !== 'ERROR')
		{
			res_type.records.unshift({ 'leave_type_id': -1, 'description': getTranslation('l_all_leave_types') });
			this.viewModel.leave_types(res_type.records);
		};

		let res_dep = await Grape.fetches.getJSON('/api/record', { 
			table: 'v_department_company',
			schema: 'savanna',
			limit: 1000,
			sortfield: 'department',
			sortorder: 'asc' 
		});

		if (res_dep.status !== 'ERROR')
		{
			for (let i = 0; i < res_dep.records.length; i++)
				res_dep.records[i].name = res_dep.records[i].department + ' (' + res_dep.records[i].company + ')';

			res_dep.records.unshift({ 'department_id': -1, 'name': getTranslation('l_all_departments') });
			this.viewModel.departments(res_dep.records);
		};
	};

	async updateData()
	{
		// destroy all date pickers
		$('.manager_date_picker').datepicker('remove');
		this.viewModel.leave_to_approve.removeAll();
		Navbar.updateLeaveRequestCount();
		Navbar.updateNotificationCount();

		let obj = {
			employee_id: Utils.get_local_storage_nullable('employee_id'),
			leave_type_id: this.viewModel.leave_type_id(),
			sortmethod: this.viewModel.sorting_method(),
			department_id: this.viewModel.department_id()
		};

		this.viewModel.loader(true);

		let res = await Grape.fetches.postJSON('/leave/get_leave_cancellation_requests', obj);
		if (res.status !== 'ERROR')
		{
			// resize and align the employee photos
			for (let i = 0; i < res.length; i++)
				alignEmployeePhoto(res[i].employee_id, '#leave_transaction_' + res[i].transaction_id);

			this.parseLeave(res);
			this.viewModel.loader(false);
		}
		else
			this.viewModel.loader(false);
	};

	parseFinalizedLeave(res)
	{
		let parsed_dates = new Array();

		for (let a = 0; a < res.length; a++)
		{
			parsed_dates[getDate(res[a].date_start)] = {
				'date': new Date(res[a].date_start),
				'type': 'use_css_class',
				'name': res[a].leave_type + ' ' +tr('Finalised'),
				'css_class': res[a].css_class_name };
		}

		return parsed_dates;
	};

	parseRequestedDates(date_array)
	{
		let parsed_dates = new Array();

		for (let a = 0; a < date_array.length; a++)
		{
			parsed_dates[getDate(date_array[a])] = {
				'date': new Date(date_array[a]),
				'type': 'use_css_class',
				'name': tr('Requested Cancellation leave day'),
				'css_class': 'request_date' };
		}

		return parsed_dates;
	}

	parseLeave(res)
	{
		this.viewModel.leave_to_approve(res);

		// insert the dates (EACH EMPLOYEE)
		for (let a = 0; a < res.length; a++)
		{
			let finalized_leave_dates = new Array();
			finalized_leave_dates = this.parseFinalizedLeave(res[a].all_finalized_leave);

			// show the leave to approve (EACH LEAVE TO APPROVE)
			res[a].temp_event_dates = new Array();
			res[a].temp_event_dates = res[a].temp_event_dates.concat(res[a].dates_included);

			// combine the leave_to_approve , holidays and finalized leave ( We process the requested dates last as in the merge dates might get overwritten, but the requests are the most important.)
			let requested_dates = new Array();
			requested_dates = this.parseRequestedDates(res[a].temp_event_dates);

			res[a].temp_event_dates = eventDates;
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, finalized_leave_dates);
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, requested_dates);

			let startdate = new Date(res[a].leave_start);
			let endDate = new Date(res[a].leave_end);
			let tmp = $('#datepicker_' + res[a].transaction_id).datepicker({
				format: 'yyyy-mm-dd',
				defaultViewDate: { year: startdate.getFullYear(), month: startdate.getMonth(), day: startdate.getDate() },
				beforeShowDay:
				(date) => {
						return setCalendarHighlightDates(date, res[a].temp_event_dates);
					},
				startDate: startdate,
				endDate: endDate
			});
		}
	};
};

export default {
	route: '[/]admin/leave_cancellation_request',
	page_class: LeaveCancellationRequest,
	template: template,
	template_filename: 'translation/leave_cancellation_request'
};
